import * as Immutable from "immutable";
export default class GroupSyncBackend {
  constructor(id, authServiceBackendId, selectionType, selection, defaultRoles, config) {
    this._value = {
      id,
      authServiceBackendId,
      selectionType,
      selection,
      defaultRoles,
      config
    };
  }
  get id() {
    return this._value.id;
  }
  get authServiceBackendId() {
    return this._value.authServiceBackendId;
  }
  get selectionType() {
    return this._value.selectionType;
  }
  get selection() {
    return this._value.selection;
  }
  get defaultRoles() {
    return this._value.defaultRoles;
  }
  get config() {
    return this._value.config;
  }
  toBuilder() {
    const { id, authServiceBackendId, selectionType, selection, defaultRoles, config } = this._value;
    return new Builder(
      Immutable.Map({
        id,
        authServiceBackendId,
        selectionType,
        selection,
        defaultRoles,
        config
      })
    );
  }
  toJSON() {
    const {
      id,
      authServiceBackendId,
      selectionType,
      selection = Immutable.Set(),
      defaultRoles = Immutable.Set(),
      config
    } = this._value;
    return {
      id,
      auth_service_backend_id: authServiceBackendId,
      selection_type: selectionType,
      selection: selection.toJS(),
      default_roles: defaultRoles.toJS(),
      config: {
        type: config == null ? void 0 : config.type,
        group_search_base: config == null ? void 0 : config.groupSearchBase,
        team_unique_id_attribute: config == null ? void 0 : config.teamUniqueIdAttribute,
        team_name_attribute: config == null ? void 0 : config.teamNameAttribute,
        okta_api_token: config == null ? void 0 : config.oktaApiToken,
        group_claims: config == null ? void 0 : config.groupsClaim
      }
    };
  }
  static fromJSON(value) {
    const {
      id,
      auth_service_backend_id: authServiceBackendId,
      selection_type: selectionType,
      selection = [],
      default_roles: defaultRoles = [],
      config
    } = value;
    return new GroupSyncBackend(
      id,
      authServiceBackendId,
      selectionType,
      Immutable.Set(selection),
      Immutable.Set(defaultRoles),
      {
        type: config.type,
        groupSearchBase: config.group_search_base,
        groupSearchPattern: config.group_search_pattern,
        teamUniqueIdAttribute: config.team_unique_id_attribute,
        teamNameAttribute: config.team_name_attribute,
        oktaApiToken: config == null ? void 0 : config.okta_api_token,
        groupsClaim: config == null ? void 0 : config.groups_claim
      }
    );
  }
  static builder() {
    return new Builder();
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  id(value) {
    return new Builder(this.value.set("id", value));
  }
  authServiceBackendId(value) {
    return new Builder(this.value.set("authServiceBackendId", value));
  }
  selectionType(value) {
    return new Builder(this.value.set("selectionType", value));
  }
  selection(value) {
    return new Builder(this.value.set("selection", value));
  }
  defaultRoles(value) {
    return new Builder(this.value.set("defaultRoles", value));
  }
  config(value) {
    return new Builder(this.value.set("config", value));
  }
  build() {
    const { id, authServiceBackendId, selectionType, selection, defaultRoles, config } = this.value.toObject();
    return new GroupSyncBackend(id, authServiceBackendId, selectionType, selection, defaultRoles, config);
  }
}
